// set global settings for ZenDesk Widget
window.zESettings = {
  webWidget: {
    color: { theme: '#FF1D4E' },
    contactForm: {
      fields: [
        {
          id: 'email'
        }
      ]
    },
  },
};

const init = () => {
  document.querySelectorAll('.js-open-contact-form').forEach(el =>
    el.addEventListener('click', openContactForm));
};

const openContactForm = event => {
  if(event) {
    event.preventDefault();
  }
  if(!window.zE) {
    return;
  }
  window.zE('webWidget', 'open');
};

export default {init, openContactForm};
